module.exports = __webpack_public_path__ + "img/my-authorized-unselect.6c6aaeab.svg";